import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";

export type UpdateKnowledgeObjectMetadataPayload = {
    readonly objectUid: string;
    readonly title: string;
};

/**
 * Command to update the metadata (currently: title) of an existing
 * KnowledgeObject (PRD-076). Mirrors the backend
 * `UpdateKnowledgeObjectMetadataCommand` — the backend handler reads
 * `objectUid` (ShortId or UUID) and `title` from the payload.
 */
export class UpdateKnowledgeObjectMetadataCommand extends AbstractCommand<UpdateKnowledgeObjectMetadataPayload> {

    public name: CommandName = CommandName.UPDATE_KNOWLEDGE_OBJECT_METADATA;

    public tags = ['entity', 'update', 'knowledge-object'];

    constructor(payload: UpdateKnowledgeObjectMetadataPayload) {
        super('knowledgeObject', payload.objectUid, payload);
    }

}
